import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import Flex from '../../../assets/images/Machines/FlexPrinting.jpg';
import Laser from '../../../assets/images/Machines/LaserCutting.png';
import Plotter from '../../../assets/images/Machines/Plotter.jpg';
import Sublimation from '../../../assets/images/Machines/SublimationSetUp.jpg';
import SelfInk from '../../../assets/images/Machines/SelfInk.jpg';


import styled from 'styled-components';

const CarouselContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f9f9f9;
  padding: 40px;
  height: 420px;
  gap: 20px;
`;

const CarouselImage = styled.img`
  width: 50%;
  height: 380px;
  object-fit: cover;
  display: block;
`;

const CarouselTextContainer = styled.div`
  padding: 20px;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
`;

const CarouselHeading = styled.h3`
  margin: 0 0 10px 0;
  font-size: 24px;
`;

const CarouselText = styled.p`
  margin: 0;
  font-size: 16px;
`;


const HomeSection8 = () => {
  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const carouselItems = [
    {
      image: Flex,
      text: 'Flex Printing Machine 512i',
      desc: ' ',
    },
    {
      image: Laser,
      text: 'Laser Cutting Machine',
      desc: ' ',
    },
    {
      image: Plotter,
      text: 'Cutting Plotter',
      desc: ' ',
    },
    {
      image: Sublimation,
      text: 'Sublimation Setup (for printing, mugs, bottles, caps,....)',
      desc: ' ',
    },
    {
      image: SelfInk,
      text: 'Self Ink Stamp Machine',
      desc: ' ',
    },
  ];
  return (
    <>
      <Carousel
        responsive={responsive}
        autoPlay={true}
        autoPlaySpeed={4000}
        infinite={true}
        showDots={false}
      >
        {carouselItems.map((item, index) => (
          <CarouselContainer key={index}>
            <CarouselImage
              src={item.image}
              alt={`Slide ${index + 1}`}
            />
            <CarouselTextContainer>
              <CarouselHeading>{item.text}</CarouselHeading>
              <CarouselText>{item.desc}</CarouselText>
            </CarouselTextContainer>
          </CarouselContainer>
        ))}
      </Carousel>
      {/* Divider-line */}
      <hr className="divider-line" style={{ margin: '0 auto' }} />
    </>
  );
};


export default HomeSection8;

